import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import TorisWebsite from './TorisWebsite/TorisWebsite'
import KrisPlayer from './KrisPlayer/KrisPlayer'
import Redirect from './Redirect/Redirect'

const root = ReactDOM.createRoot(document.getElementById('root'))
const url = 'https://docs.google.com/forms/d/e/1FAIpQLSfleaMYP6bleul1BeT-KnTeWDv6yAHyw98gglqxWpVwaUauXQ/viewform?usp=header'

root.render(
  <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route exact path="/kris" element = { <KrisPlayer/> } />
          <Route exact path="/frogs" element={<Redirect url={ url } />} />
          <Route exact path="*" element={ <TorisWebsite/> } />
        </Routes>
      </BrowserRouter>
  </React.StrictMode>
)
